var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          class: ["btn", _vm.buttonTypeClass],
          attrs: { disabled: _vm.disabled || _vm.loading }
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.loading
        ? _c("div", {
            staticClass: "spinner-border spinner-border-sm text-light mr-1"
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _vm.isDuotone
        ? [
            !_vm.loading && _vm.icon
              ? _c("font-awesome-icon", { attrs: { icon: ["fad", _vm.icon] } })
              : _vm._e()
          ]
        : [
            !_vm.loading && _vm.icon
              ? _c("font-awesome-icon", { attrs: { icon: ["far", _vm.icon] } })
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }